import { render, staticRenderFns } from "./UserListTable.vue?vue&type=template&id=21bf6581&scoped=true"
import script from "./UserListTable.vue?vue&type=script&lang=js"
export * from "./UserListTable.vue?vue&type=script&lang=js"
import style0 from "./UserListTable.vue?vue&type=style&index=0&id=21bf6581&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bf6581",
  null
  
)

/* custom blocks */
import block0 from "./UserListTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports